import React from 'react'
import PropTypes from 'prop-types'
import { NumberSpot } from 'components/qstrap'

const propTypes = {
  name: PropTypes.string.isRequired,
  childCount: PropTypes.number.isRequired,
}

const StudyField = props => (
  <div className="study-field">
    <div className="link-label bold">
      <span>{props.name}</span>
    </div>
    <NumberSpot className="pull-right" number={props.childCount} />
  </div>
)

StudyField.propTypes = propTypes

export default StudyField
